import { Form, Modal, Button, Row } from 'react-bootstrap'
import styled, { css } from 'styled-components'
import { device } from 'utils/device'
import {
  FaTimes,
  FaRegSave,
  FaExternalLinkAlt,
} from 'react-icons/fa'
import { Title } from 'components'
import ReactTooltip from 'react-tooltip'

export const HiddenInput = styled(Form.Control)`
  display: none;
`

export const Label = styled(Form.Label)`
  font-weight: 600;
  width: 100%;
  position: relative;
`

export const iconStyles = css`
  font-size: 1.1rem;
`

export const buttonStyles = css`
  border: 0;
  margin-top: 1rem;
  margin-right: 1rem;
  > span {
    font-size: 0.8rem;
  }

  &:disabled {
    cursor: not-allowed;
  }
`

export const RegSave = styled(FaRegSave)`
  ${iconStyles}
`
export const Times = styled(FaTimes)`
  ${iconStyles}
`

export const SaveButton = styled(Button)`
  background-color: ${(props) => props.theme.button.backgroundColor};
  ${buttonStyles}
`

export const CancelButton = styled(Button)`
  background-color: ${(props) => props.theme.button.secondary};
  ${buttonStyles}
`

export const Header = styled(Modal.Header)`
  background-color: ${(props) => props.theme.palette.secondary[0]};
  height: 3rem;
  color: ${(props) => props.theme.palette.grayscale[0]};
  padding: 0.5rem 1rem;
  border-top-left-radius: 0.8rem;
  border-top-right-radius: 0.8rem;
  padding-left: 2rem;

  > .h4 {
    font-size: 1rem;
    line-height: 2;
    font-weight: 600;
  }

  > button {
    color: white;
  }
`

export const Body = styled(Modal.Body)`
  padding: 1rem 2rem;
`

export const NoMargin = styled(Form.Group)`
  margin-bottom: 0;
`

export const ModalContainer = styled(Modal)`
  font-size: 0.8rem;

  .modal-content {
    border-radius: 1rem;
    border-color: transparent;
  }

  > div {
    max-width: 700px;
  }

  input,
  textarea {
    font-size: 0.8rem;
  }

  .form-row > .col {
    margin-right: 2.5rem;
    @media ${device.mobileL} {
      margin-right: 0;
    }
  }
`

export const PageButton = styled(Button)`
  color: #305daa;
  font-size: 0.9rem;
  padding: 0.3rem;
`

export const Toolbar = styled(Row)`
  margin-bottom: 1rem;
`

export const TitleName = styled(Title)`
  font-size: 1.5rem;
  white-space: normal;
  overflow-wrap: break-word;
`

export const ExternalLink = styled(FaExternalLinkAlt)`
  position: absolute;
  right: 1.5rem;
  font-size: 1rem;
  top: -2px;
  cursor: pointer;
`

export const Elegibility = styled.p`
  white-space: pre-wrap;
`

export const ProgramUrl = styled.div`
  cursor: pointer;
  white-space: normal;
  overflow-wrap: anywhere;
  word-break: break-all;
`

export const DiffTooltip = styled(ReactTooltip)`
  &.__react_component_tooltip {
    border-radius: 4px;
    padding: 8px 10px;
    background-color: ${(props) => props.theme.palette.grayscale[8]};
    color: ${(props) => props.theme.palette.grayscale[1]};
    border: solid 1px ${(props) => props.theme.palette.grayscale[4]};

    &.place-bottom::before {
      border-bottom-color: ${(props) => props.theme.palette.grayscale[4]};
    }

    &.place-bottom::after {
      border-bottom-color: ${(props) => props.theme.palette.grayscale[8]};
    }

    &.place-top::before {
      border-top-color: ${(props) => props.theme.palette.grayscale[4]};
    }

    &.place-top::after {
      border-top-color: ${(props) => props.theme.palette.grayscale[8]};
    }
  }
  
`;
